import React from "react";
import moment from "moment";
import Checkbox from "../../../../../components/shared/Checkbox/Checkbox";
import { PictureInPictureVideo } from "../PictureInPictureVideo";
import { FiMinusCircle } from "react-icons/fi";
import { FaCirclePlus } from "react-icons/fa6";

const isTanstackRow = (row) =>
  Boolean(
    row &&
      "getIsSelected" in row &&
      "toggleSelected" in row &&
      "getCanSelect" in row
  );

// type VideoPathCellProps = {
//     actionType: 'add' | 'checkbox' | 'delete' | 'none'
//     collectionVideoIds?: string[]
//     isHeader?: boolean
//     row?: null | VideoRow
//     table?: Table<VideoT>
//     onAction?: (videoId: string) => void
// }

export function VideoPathCell({
  actionType = "none",
  collectionVideoIds,
  isHeader = false,
  onAction,
  row,
  table,
}) {
  // Render video path content
  const renderVideoPath = () => {
    const videoPath = row?.original?.videoPath;
    const videoCreated = row?.original?.videoCreated;

    if (videoPath?.includes(".com")) {
      return (
        <div className="flex items-center gap-3">
          <PictureInPictureVideo videoPath={videoPath} />
          <span className="text-gray700 text-sm">
            {moment(Number(videoCreated)).format("MM/DD/YY HH:mm")}
          </span>
        </div>
      );
    }
    return <b>{videoPath}</b>;
  };

  // Header rendering for checkbox type
  if (isHeader && actionType === "checkbox" && table) {
    return (
      <div className="flex items-center gap-1">
        <Checkbox
          isChecked={
            table.getIsAllRowsSelected() || table.getIsSomeRowsSelected()
          }
          isSome={
            table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
          }
          onChange={(value) => table.toggleAllRowsSelected(value)}
        />
        <span>Date</span>
      </div>
    );
  }

  // Regular header (non-checkbox)
  if (isHeader) {
    return <span>Date</span>;
  }

  // Cell rendering - row must exist for cells
  if (!row) {
    return null;
  }

  const videoId = row.original?.id;
  const selectableRow = isTanstackRow(row) ? row : null;
  const gapClass = actionType === "checkbox" ? "gap-1" : "gap-2";

  return (
    <div className={`flex items-center ${gapClass}`}>
      {actionType === "checkbox" && selectableRow && (
        <Checkbox
          isChecked={selectableRow.getIsSelected()}
          isDisabled={!selectableRow.getCanSelect()}
          onChange={(value) => selectableRow.toggleSelected(value)}
        />
      )}

      {actionType === "delete" && (
        <FiMinusCircle
          className="text-gray500 min-w-5 size-5 cursor-pointer"
          onClick={() => onAction?.(videoId)}
        />
      )}

      {actionType === "add" && (
        <>
          {collectionVideoIds?.includes(videoId) ? (
            <div className="min-w-5 size-5" />
          ) : (
            <FaCirclePlus
              className="text-primary500 min-w-5 size-5 cursor-pointer"
              onClick={() => onAction?.(videoId)}
            />
          )}
        </>
      )}

      {renderVideoPath()}
    </div>
  );
}
